import { useContext } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import { Link } from "react-router-dom";

// firebase
import {auth} from "./auth/fireAuth";
import {AuthContext} from "./store/AuthProvider";

const NavBar = () => {
  const {uidState, unameState, _} =useContext(AuthContext);
  const [uid, setUid] =uidState; const [uname, setUname] =unameState;
  
  return (
    <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark">
      <Link to="/">
        <Navbar.Brand href="#/">MCD</Navbar.Brand>
      </Link>
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="ml-auto">
          <Link to="/leaderboard">
            <Nav.Link eventKey="1" href="#/leaderboard">
              Leaderboard
            </Nav.Link>
          </Link>
          
          {uname ?(
            <>
              <Link to={`/profile=${uid}`}>
                <Nav.Link eventKey="2" href="#/profile">
                  {uname}
                </Nav.Link>
              </Link>
              <Link to="/">
                <Nav.Link eventKey="3" href="#/logout" onClick={() => {auth.signOut()}}>
                  Logout
                </Nav.Link>
              </Link>
            </>
          ) : (
            <>
              <Nav.Link eventKey="4" href="/login">
                Login
              </Nav.Link>
              <Nav.Link eventKey="5" href="/register">
                Register
              </Nav.Link>
            </>
          )}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default NavBar;
